<h5 mat-dialog-title>Quote Status</h5>
<form #statusForm="ngForm" (ngSubmit)="saveStatus(statusForm)">
  <div mat-dialog-content>
    <div class="form-group row">
      <label for="lostReasonType_ID" class="col-sm-4 col-form-label">
        <span class="warning">* </span>
        Lost Reason
      </label>
      <div class="col-sm-8">
        <select class="form-control select-bidit" name="lostReasonType_ID" id="lostReasonType_ID"
                required=""
                [(ngModel)]="data.lostReasonType_ID" #lostReasonType_ID="ngModel">
          <option [ngValue]="undefined">-</option>
          <option *ngFor="let reason of data.lostReasonTypes" [ngValue]="reason.lostReasonType_ID">{{reason.lostReasonType_Desc}}</option>
        </select>
        <div [hidden]="!statusForm.submitted || lostReasonType_ID.valid"
             class="alert alert-danger">
          Enter a lost reason
        </div>
      </div>
    </div>
    <div class="form-group row">
      <label for="lost_competitor" class="col-sm-4 col-form-label">Lost To</label>
      <div class="col-sm-8">
        <select class="form-control select-bidit" name="competitor_ID" id="competitor_ID"
                [(ngModel)]="data.competitor_ID" #competitor_ID="ngModel">
          <option [ngValue]="undefined">-</option>
          <option *ngFor="let competitor of data.competitors" [ngValue]="competitor.competitor_ID">{{competitor.competitor_Desc}}</option>
        </select>
      </div>
    </div>
    <div class="form-group row">
      <label for="quote_LostNote" class="col-sm-4 col-form-label">Note</label>
      <div class="col-sm-8">
        <textarea class="form-control" name="quote_LostNote" id="quote_LostNote" rows="3"
                  [(ngModel)]="data.quote_LostNote" #quote_LostNote="ngModel"></textarea>
      </div>
    </div>
  </div>
  <div mat-dialog-actions>
    <button mat-button type="submit" class="btn btn-bidit-submit mr-1">Submit</button>
    <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
  </div>
</form>
